import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PermitMapViewComponent } from "./components/permit-map-view/permit-map-view.component";
import { PtwDashboardComponent } from "./components/ptw-dashboard/ptw-dashboard.component";
import { RaisePermitComponent } from "./components/raise-permit/raise-permit.component";

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'raise-permit'
  },
  {
    path: 'raise-permit',
    component: RaisePermitComponent
  },
  {
    path: 'raise-permit/:permitId',
    component: RaisePermitComponent
  },
  {
    path: 'permit-overview',
    component: PtwDashboardComponent
  },
  {
    path: 'map-view',
    component: PermitMapViewComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
})
export class PermitToWorkRoutingModule { }
